import React from 'react';
import { FiDownload } from 'react-icons/fi';

const SaveDialog = ({
  show,
  onClose,
  jsonData,
  saveFileName,
  setSaveFileName,
  onDownloadFile
}) => {

  const handleFileSave = async () => {
    
    // File System Access API - funktioniert nur über HTTPS oder localhost
    if (window.showSaveFilePicker && typeof window.showSaveFilePicker === 'function' && window.isSecureContext) {
      try {
        // Direkt Filebrowser öffnen
        const fileHandle = await window.showSaveFilePicker({
          suggestedName: (saveFileName || 'syllabus') + '.syllabus',
          types: [{
            description: 'Syllabus-Dateien',
            accept: {
              'application/json': ['.syllabus']
            }
          }]
        });
        
        const writable = await fileHandle.createWritable();
        await writable.write(jsonData);
        await writable.close();
        
        onClose();
        return;
        
      } catch (err) {
        if (err.name === 'AbortError') {
          return; // Benutzer hat abgebrochen
        }
        // Bei anderen Fehlern: Fallback verwenden
      }
    }
    
    // Fallback: Download
    if (typeof onDownloadFile === 'function') {
      onDownloadFile(saveFileName);
    }
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        minWidth: '400px',
        maxWidth: '90vw',
        maxHeight: '80vh',
        overflow: 'auto'
      }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiDownload />
          Backup lokal speichern
        </h3>

        <p style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#666' }}>
          {window.showSaveFilePicker && window.isSecureContext 
            ? 'Speichern Sie die Datei direkt auf Ihrem Computer:'
            : 'Die moderne Datei-API ist nicht verfügbar (benötigt HTTPS). Geben Sie einen Dateinamen ein für den Download:'}
        </p>
        
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>
            Dateiname:
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <input
              type="text"
              value={saveFileName}
              onChange={(e) => setSaveFileName(e.target.value)}
              placeholder="Mein Syllabus"
              style={{
                flex: 1,
                padding: '8px 12px',
                border: '1px solid #ccc',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
            <span style={{ fontSize: '14px', color: '#666' }}>.syllabus</span>
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' }}>
          <button
            style={{
              padding: '8px 16px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              backgroundColor: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
            onClick={onClose}
          >
            Abbrechen
          </button>
          <button
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '6px',
              backgroundColor: '#4caf50',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontWeight: '500'
            }}
            onClick={handleFileSave}
          >
            <FiDownload />
            Datei herunterladen
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveDialog;
